module.exports = __webpack_public_path__ + "static/media/broken_bone.9ec3242e.svg";